import { Dayjs } from 'dayjs'
import { getDateRanges } from './getDateRanges'

export const getEndDate = (): string =>
  (getDateRanges()['last-7-days'] as [Dayjs, Dayjs])[1].toJSON()
